import { ReelInit, ReelObject, SymbolObject } from "./ReelInit";

// import { Sprite } from 'pixi.js';
// import { Spine } from '@esotericsoftware/spine-pixi-v8';
import {
    Easing,
    Group,
    Tween
} from "tweedle.js";
import { getSpineSymbol, /*getSymbol,*/ isLandingAnimationExist } from "../config/getSymbol";
import { /*spinResponse, initData, */ spinData /*, WinObject*/ } from '../server/getServerResposesFun';

// import { betValueGlobal } from "../config/GlobalVariableConfig";

import { sound } from "@pixi/sound";

import {
    REEL_DIVIDER,
    REEL_NUMBERS,
    // NUMBER_OF_SYMBOLS,
    SHOWN_REELS_HEIGHT,
    SYMBOL_HEIGHT,
    SYMBOL_WIDTH,
    SYMBOLS_PER_REEL
} from "../config/reelConfig";

// import { Ui } from "../ui/Ui"
// import { ColorOverlayFilter } from "pixi-filters";
import { isQuickBtnOnGlobal, isSuperQuickBtnOnGlobal, jurisdictionGlobal } from "../config/GlobalVariableConfig";
import { reelSpinEmitter } from "./Reels";


// import { isTurboBtnOn } from "../config/GlobalVariableConfig";
// import { casinoEventEmitter } from "../core/CasinoChannelHandler";

const reelTweenGroup = new Group();
const textTweenGroup = new Group();


export class ReelSpin extends ReelInit {

    // private spinData: SpinDataObject;

    // private ui: Ui;

    public running = false;


    private quickStop = false;
    private superQuickStop = false;

    private resolveReelsStop: (() => void) | null = null;

    // private isMultPannelOn = false;

    constructor() {
        super();

        this.quickStop = isQuickBtnOnGlobal;
        this.superQuickStop = isSuperQuickBtnOnGlobal;

        this.setSpinTimeJurisdiction();

    }





    private resetTweenGroup() {
        reelTweenGroup.removeAll();
    }


    public updateReelSpin(): void {

        Group.shared.update();
        reelTweenGroup.update();
        textTweenGroup.update();


    }


    public async waitForReelsToStop(): Promise<void> {
        return new Promise<void>((resolve) => {
            this.resolveReelsStop = resolve;
        });
    }



    public async putGiantWild(currentRespinIndex: number): Promise<void> {


        let giantWilds;
        if (spinData.respins[currentRespinIndex].giantWilds?.length > 0) {
            giantWilds = spinData.respins[currentRespinIndex].giantWilds;

            await new Promise(resolve => setTimeout(resolve, 200));

            reelSpinEmitter.emit('updateSurgeMeter', 0);

        }
        else {
            return Promise.resolve();
        }

        // const colorOverlayFilter = new ColorOverlayFilter();
        // colorOverlayFilter.color = "#000000";
        // colorOverlayFilter.alpha = 0;

        // const tween = new Tween(colorOverlayFilter, textTweenGroup)
        //     .to({ alpha: 0.7 }, 100)
        //     .onComplete(() => {
        //         textTweenGroup.remove(tween);
        //     })
        //     .start();


        this.allReelArray.forEach((reel) => {
            reel.symbols.forEach((symbol) => {
                // symbol.symbol.filters = [colorOverlayFilter];
                symbol.symbol.tint = "0x555555";
            });
        })

        const animationPromises: Promise<void>[] = [];

        sound.play("Giant_Wild", { volume: 1 });

        giantWilds.forEach((wildSymbol) => {

            wildSymbol.positions?.forEach((positions, index) => {
                const reelNum: number = positions[0];
                const posNum: number = positions[1];

                // // Clear the existing symbol
                // this.allReelArray[reelNum].symbols[posNum].multText.text = "";
                // this.allReelArray[reelNum].symbols[posNum].multVal = 0;

                const symbol = this.allReelArray[reelNum].symbols[posNum].symbol;
                // symbol.filters = [];
                symbol.tint = "0xffffff";

                if (index == 3) {
                    symbol.destroy();

                    const giantWildSymbolId = 100;
                    const wildSymbol = getSpineSymbol(giantWildSymbolId);

                    wildSymbol.position.set(-REEL_DIVIDER - (SYMBOL_WIDTH / 2), -REEL_DIVIDER - (SYMBOL_HEIGHT / 2));

                    reelSpinEmitter.emit('shakeEffect');

                    const animationPromise = new Promise<void>((resolve) => {
                        wildSymbol.state.setAnimation(0, "appear", false).listener = {
                            complete: () => {
                                wildSymbol.state.clearListeners();
                                resolve();
                            }
                        }
                    })

                    animationPromises.push(animationPromise);

                    this.allReelArray[reelNum].symbols[posNum].symbol = wildSymbol;
                    this.allReelArray[reelNum].symbols[posNum].id = giantWildSymbolId;
                    this.allReelArray[reelNum].symbols[posNum].view.addChildAt(wildSymbol, 0);
                    // this.allReelArray[reelNum].symbols[posNum].isWin = false;
                }
                else {
                    symbol.alpha = 0;
                    // this.allReelArray[reelNum].symbols[posNum].isWin = true;
                }

            });
        });

        try {
            if (animationPromises.length > 0) {
                await Promise.all(animationPromises);

                await new Promise(resolve => setTimeout(resolve, 200));

                this.allReelArray.forEach((reel) => {
                    reel.symbols.forEach((symbol) => {
                        // symbol.symbol.filters = [];
                        symbol.symbol.tint = "0xffffff";
                    });
                })

                await new Promise(resolve => setTimeout(resolve, 300));

            }
        } catch (error) {
            console.error("Error during wild animations:", error);
            throw error;
        }

    }



    public async putRandomWild(currentRespinIndex: number): Promise<void> {
        let wildSymbols;
        if (spinData.respins[currentRespinIndex].swirl.length > 0) {
            wildSymbols = spinData.respins[currentRespinIndex].swirl;
        } else {
            return;
        }

        // const colorOverlayFilter = new ColorOverlayFilter();
        // colorOverlayFilter.color = "#000000";
        // colorOverlayFilter.alpha = 0;

        // const tween = new Tween(colorOverlayFilter, textTweenGroup)
        //     .to({ alpha: 0.7 }, 100)
        //     .onComplete(() => {
        //         textTweenGroup.remove(tween);
        //     })
        //     .start();

        this.allReelArray.forEach((reel) => {
            reel.symbols.forEach((symbol) => {
                // symbol.symbol.filters = [colorOverlayFilter];
                symbol.symbol.tint = "0x555555";


            });
        });


        //remove the filter from all swril symbols;
        for (const wildSymbol of wildSymbols) {
            const swrilReelNum = wildSymbol.reelNum;
            const swrilPosNum = wildSymbol.posNum;
            const swril = this.allReelArray[swrilReelNum].symbols[swrilPosNum].symbol;
            // swril.filters = [];
            swril.tint = "0xffffff";
        }

        const animationPromises: Promise<void>[] = [];

        for (const wildSymbol of wildSymbols) {
            // const multVal = 0; // wildSymbol.multiplier;
            const swrilReelNum = wildSymbol.reelNum;
            const swrilPosNum = wildSymbol.posNum;
            const swril = this.allReelArray[swrilReelNum].symbols[swrilPosNum].symbol;

            // swril.filters = [];

            if (wildSymbol.addedMult > 0) {

                await new Promise<void>((resolve) => {
                    let currentVal = 0;
                    const targetVal = 1;
                    const tween = new Tween({ x: currentVal }, textTweenGroup)
                        .to({ x: targetVal }, 500)
                        .onStart(() => {

                            sound.play("Special_Symbol_Provides_Additional_Multiplier", { volume: 1 });

                            this.allReelArray[swrilReelNum].symbols[swrilPosNum].multText.text = `X${wildSymbol.addedMult}`;
                            this.allReelArray[swrilReelNum].symbols[swrilPosNum].multVal = wildSymbol.addedMult;
                        })
                        .onUpdate((object) => {
                            currentVal = object.x;
                            this.allReelArray[swrilReelNum].symbols[swrilPosNum].multText.scale = currentVal;
                        })
                        .easing(Easing.Bounce.Out)
                        .onComplete(() => {
                            textTweenGroup.remove(tween);
                            this.allReelArray[swrilReelNum].symbols[swrilPosNum].multText.scale = 1;
                            resolve();
                        })
                        .start();
                });

                await new Promise(resolve => setTimeout(resolve, 500));

                reelSpinEmitter.emit('updateMultiplier', wildSymbol.updatedRespinMult);

                await new Promise<void>((resolve) => {
                    let currentVal = 1;
                    const targetVal = 0;
                    const tween = new Tween({ x: currentVal }, textTweenGroup)
                        .to({ x: targetVal }, 200)
                        .onUpdate((object) => {
                            currentVal = object.x;
                            this.allReelArray[swrilReelNum].symbols[swrilPosNum].multText.scale = currentVal;
                        })
                        .onComplete(() => {
                            textTweenGroup.remove(tween);
                            this.allReelArray[swrilReelNum].symbols[swrilPosNum].multText.scale = 0;
                            this.allReelArray[swrilReelNum].symbols[swrilPosNum].multText.text = "";
                            this.allReelArray[swrilReelNum].symbols[swrilPosNum].multVal = 0;
                            resolve();
                        })
                        .start();
                });


            }


            // Wait for swril animation to complete
            await new Promise<void>((resolve) => {
                reelSpinEmitter.emit('shakeEffect');
                sound.play("Special_Symbol_Activates", { volume: 0.5 });
                swril.state.setAnimation(0, "land_character", false).listener = {
                    complete: () => {
                        swril.state.clearListeners();
                        resolve();
                    },
                };
            });

            sound.play("Special_Symbol_Provides_Additional_Wilds", { volume: 0.5 });





            // Animate corresponding positions
            wildSymbol.positions?.forEach((positions) => {
                const [reelNum, posNum] = positions;
                const symbolObj = this.allReelArray[reelNum].symbols[posNum];
                const symbol = symbolObj.symbol;

                // symbol.filters = [];
                symbol.tint = "0xffffff";

                const animationPromise = new Promise<void>((resolve) => {
                    symbol.state.setAnimation(0, "splash", false).listener = {
                        complete: () => {
                            symbol.state.clearListeners();
                            symbol.destroy();

                            const wildSymbol = getSpineSymbol(0);
                            wildSymbol.state.setAnimation(0, "land", false);
                            symbolObj.symbol = wildSymbol;
                            symbolObj.id = 0;
                            symbolObj.view.addChildAt(wildSymbol, 0);
                            symbolObj.isWin = false;
                            symbolObj.multText.text = "";
                            symbolObj.multVal = 0;

                            resolve();
                        },
                    };
                });

                animationPromises.push(animationPromise);

                // // Add multiplier text tween if needed
                // if (multVal > 0) {
                //     const tweenPromise = new Promise<void>((resolve) => {
                //         let currentVal = 0;
                //         const targetVal = 1;
                //         const tween = new Tween({ x: currentVal }, textTweenGroup)
                //             .to({ x: targetVal }, 200)
                //             .onUpdate((object) => {
                //                 currentVal = object.x;
                //                 symbolObj.multText.scale = currentVal;
                //             })
                //             .easing(Easing.Bounce.Out)
                //             .onComplete(() => {
                //                 textTweenGroup.remove(tween);
                //                 symbolObj.multText.scale = 1;
                //                 resolve();
                //             })
                //             .start();
                //     });
                //     animationPromises.push(tweenPromise);
                // }
            });

            try {
                if (animationPromises.length > 0) {
                    await Promise.all(animationPromises);
                    await new Promise((resolve) => setTimeout(resolve, 200));

                    // await this.addMultiplierIntoTopMeter(currentRespinIndex);
                }
            } catch (error) {
                console.error("Error during wild animations:", error);
                throw error;
            }
        }


        this.allReelArray.forEach((reel) => {
            reel.symbols.forEach((symbol) => {
                // symbol.symbol.filters = [];
                symbol.symbol.tint = "0xffffff";
            });
        });

        await new Promise((resolve) => setTimeout(resolve, 200));

    }






    private generateSymbolRemoveArray(currentRespinIndex: number): number[][] {
        // Initialize the 2D array with random values
        // const SYMBOLS_PER_REEL = 3;  // Number of rows
        // const REEL_NUMBERS = 5;      // Number of columns

        const winArray: number[][] = [];
        for (let j = 0; j < REEL_NUMBERS; j++) {
            const col: number[] = [];
            for (let i = 0; i < SYMBOLS_PER_REEL; i++) {
                col.push(0);
            }
            winArray.push(col);
        }


        spinData.respins[currentRespinIndex].cascadePositions?.forEach((winSymbol) => {

            const reelNum: number = winSymbol[0];
            const posNum: number = winSymbol[1];

            // // Mark the position as 1
            winArray[reelNum][posNum] = 1;

        })


        return winArray;
    }




    private markSymbolWin(currentRespinIndex: number): void {

        // please mind the currentRespinIndex-1 because the win symbols of previous respin will be moved up
        const cascadeArray: number[][] = this.generateSymbolRemoveArray(currentRespinIndex - 1);

        // console.log("after markSymbolWin", cascadeArray);

        // console.log(`inside winTemp`);
        // console.log(winArray);
        for (let j = 0; j < this.allReelArray.length; j++) {
            const reelObj: ReelObject = this.allReelArray[j];
            reelObj.symbols.forEach((symbol, i) => {

                // by default isWin is false, but when wild is placed on a symbols isWin become "true", in that case we will treat that symbols as non-win symbol
                if (cascadeArray[j][i] === 1) {//} && !symbol.isWin) {  //mind the order of j & i
                    symbol.isWin = true;
                }
                else {
                    symbol.isWin = false;
                }
            })
        }
        // console.log(this.allReelArray);
    }


    //setDroppingSymbols
    private setDroppingSymbols(reelObj: ReelObject): void {

        // if(reelObj.reelIndex>0) return;

        const symbolsY: number[] = reelObj.symbols.map(symbol => symbol.y);
        const droppingSymbols: SymbolObject[] = [];

        // console.log(symbolsY);

        let winSymbolCount = 0;
        let totalSymbols = reelObj.symbols.length;
        let id = reelObj.symbols.length;


        //search loop for non win symbols
        for (let i = reelObj.symbols.length - 1; i >= 0; i--) {

            const symbol = reelObj.symbols[i];
            if (!symbol.isWin) {

                id--;
                symbol.symbolIndex = id;
                symbol.y = symbolsY[id];  //moveAReelStep2()-> will move symbols from their current location to symbol.y

                droppingSymbols.push(symbol);

            }
        }

        //search loop for winning symbols
        for (let i = reelObj.symbols.length - 1; i >= 0; i--) {

            const symbol = reelObj.symbols[i];
            if (symbol.isWin) {

                winSymbolCount++;

                id--;
                symbol.symbolIndex = id;
                symbol.y = symbolsY[id];


                symbol.view.y = symbolsY[totalSymbols - winSymbolCount] - SHOWN_REELS_HEIGHT - 100; // 50 for slighlty up so that symbols wont visible when come on top
                // also change the texture of symbol in real data

                droppingSymbols.push(symbol);

            }
        }

        // reverse the droppingSymbols and push in reelObj.symbols
        reelObj.symbols = [];
        for (let i = droppingSymbols.length - 1; i >= 0; i--) {
            reelObj.symbols.push(droppingSymbols[i]);
        }



    }

    public async cacadingReels(currentRespinIndex: number): Promise<void> {


        this.markSymbolWin(currentRespinIndex);
        // console.log("after markSymbolWin", this.allReelArray);

        // await new Promise(resolve => setTimeout(resolve, 100));

        this.allReelArray.forEach((reelObj) => {
            this.setDroppingSymbols(reelObj);
        })

        // debugger;

        // console.log("after markSymbolWin", this.allReelArray);

    }


    private async spinAReel(reelObj: ReelObject, isNewSpin: boolean): Promise<void> {




        // console.log(reelObj.symbols)

        // reelObj.container.visible=true;
        // this.reelOverlayContainer.visible = false;

        // if (currentRespinIndex == 0) {
        if (isNewSpin) {
            // this.isMultPannelOn = false;
            await this.moveAReelStep1(reelObj); /// *********** just to check
        }


    }


    // Function that returns a promise which resolves when dataFetched is true
    public waitForData(): Promise<void> {
        return new Promise<void>((resolve) => {

            if (spinData.dataFeatched) {
                resolve();
            }

            const checkInterval = setInterval(() => {
                if (spinData.dataFeatched) {
                    clearInterval(checkInterval);
                    resolve();
                }
            }, 100); // Check every 100ms

        });
    }

    // private async knockoutFeatureCellOnOff(currentRespinIndex: number, isCellOn: boolean): Promise<void> {

    //     const animationPromises: Promise<void>[] = [];

    //     const specialPositions = spinData.respins[currentRespinIndex].specialPositions;
    //     if (specialPositions.length == 0) return Promise.resolve();



    //     if (isCellOn) {
    //         sound.play('Cell_Highlight', { volume: 0.3 });
    //         if (!this.isMultPannelOn) {
    //             reelSpinEmitter.emit('knockoutFeature');
    //             this.isMultPannelOn = true;
    //         }
    //     }

    //     specialPositions.forEach((specialPosition) => {
    //         const reelNum: number = specialPosition[0];
    //         const posNum: number = specialPosition[1];

    //         const cell = this.allReelArray[reelNum].cells[posNum]


    //         const animationPromise = new Promise<void>((resolve) => {
    //             cell.state.setAnimation(0, isCellOn ? "feature_on" : "feature_off", false).listener = {
    //                 complete: () => {
    //                     cell.state.clearListeners();
    //                     resolve();
    //                 },
    //             };
    //         });
    //         animationPromises.push(animationPromise);
    //     });

    //     try {
    //         if (animationPromises.length > 0) {
    //             await Promise.all(animationPromises);

    //             if (isCellOn) {
    //                 await new Promise(resolve => setTimeout(resolve, 250));
    //             }
    //         }
    //     } catch (error) {
    //         console.error("Error during knockoutFeatureCellOnOff:", error);
    //         throw error;
    //     }
    // }

    public async moveAReelStep1(reelObj: ReelObject): Promise<void> {

        return new Promise<void>((resolve) => {

            reelObj.symbols.forEach((symbol, k) => {

                const initialPos = symbol.y;
                const symbolContainer = symbol.view;

                const tween = new Tween(symbolContainer, reelTweenGroup)
                    .to({ y: initialPos + SHOWN_REELS_HEIGHT }, this.superQuickStop ? 50 : 250)
                    .delay((this.quickStop || this.superQuickStop) ? 0 : 25 * (reelObj.symbols.length - 1 - k))
                    .easing(Easing.Cubic.In)
                    .onComplete(() => {
                        symbolContainer.y = initialPos - SHOWN_REELS_HEIGHT - 50; // 50 for slighlty up so that symbols wont visible when come on top
                        // this.spinReel2(reelObj);
                        reelTweenGroup.remove(tween);

                        if (k == 0) {
                            resolve();
                            return;
                        }
                    })
                    .start();
            })
            //

        })
    }



    // private getWildMult(currentRespinIndex: number, reelNum: number, posNum: number): number {

    //     let multValue = 0;

    //     for (const wildSymbol of spinData.respins[currentRespinIndex].wildSymbols) {
    //         if (wildSymbol.posistions[0][0] === reelNum && wildSymbol.posistions[0][1] === posNum) {
    //             return wildSymbol.multiplier;
    //         }
    //     }

    //     return multValue; // This ensures a value is always returned
    // }

    // public resetReelsMaxWin() {

    //     console.log("inside resetReelsMaxWin", this.allReelArray);

    //     this.allReelArray.forEach((reelObj) => {
    //         reelObj.symbols.forEach((symbol) => {

    //             const id = symbol.id;
    //             const multVal = symbol.multVal;

    //             if (id == 0) {
    //                 symbol.symbol.state.setAnimation(0, multVal === 0 ? "activate" : "activate", false);

    //                 if (multVal !== 0) {
    //                     symbol.multText.text = `${multVal}x`;
    //                 }
    //             }
    //             else {
    //                 symbol.symbol.state.setAnimation(0, "static", false);
    //             }

    //         })
    //     })

    //     // await new Promise(resolve => setTimeout(resolve, 100));
    // }


    private async moveAReelStep2(reelObj: ReelObject, currentRespinIndex: number, isNewSpin: boolean): Promise<void> {



        // return new Promise<void>((resolve) => {

        // console.log("inside moveAReelStep2", reelObj.reelIndex)
        // replace the symbols with backend data

        // const collectionSymbols: Sprite[] = reelObj.symbols.map(symbol => symbol.view);
        const predifinedSymbolData: number[] = spinData.respins[currentRespinIndex].reelSymbols[reelObj.reelIndex];


        // this.swapTextures(collectionSymbols, predefinedReelImageData)

        let swirlLanded = false;

        // console.log(predifinedSymbolData);
        reelObj.symbols.forEach((symbol, i) => {

            let id = predifinedSymbolData[i];

            // symbol.isWin = false;

            symbol.symbol.alpha = 1;

            if (symbol.id != id) {
                symbol.symbol.destroy();
                symbol.multText.text = "";
                symbol.multVal = 0;

                const newSym = getSpineSymbol(id);
                symbol.view.addChildAt(newSym, 0);
                symbol.id = id;
                symbol.symbol = newSym;
                symbol.isWin = false;
                symbol.symbolIndex = i;

                if (id == 13) {
                    swirlLanded = true;
                }

                // it was in 8-bit, need to check
                // if (id == 0) {
                //     symbol.symbol.state.setAnimation(0, multVal === 0 ? "appear_static" : "wild_multiplier_appear_static", false);
                // }
            }
            else {

                // it was in 8-bit, need to check
                // symbol.symbol.state.setAnimation(0, "static", false); // 
                symbol.isWin = false;
                symbol.symbolIndex = i;
            }



        });

        // adjust the layering 
        for (let i = 0; i < SYMBOLS_PER_REEL; i++) {
            const symbol = reelObj.symbols.find(symbol => symbol.symbolIndex === i);
            reelObj.container.addChild(symbol.view);
        }




        // move the symbols down

        // console.log(`in spinReel2 ${reelObj.reelIndex}`);
        // console.log(reelObj.symbols);
        // console.log(predifinedSymbolData);

        // await new Promise(resolve => setTimeout(resolve, 3000));

        let isReelStopSoundPlayed = false
        const animationPromises: Promise<void>[] = [];

        reelObj.symbols.forEach((symbol, k) => {
            const targetPos = symbol.y;
            const symbolContainer = symbol.view;

            if (targetPos === symbolContainer.y) {
                // No animation needed, resolve immediately for this symbol
                animationPromises.push(Promise.resolve());
            } else {
                const promise = new Promise<void>((resolve) => {
                    const tween = new Tween(symbolContainer, reelTweenGroup)
                        .to({ y: targetPos }, this.superQuickStop ? 50 : 250)
                        .delay((this.quickStop || this.superQuickStop) ? 0 : 25 * (reelObj.symbols.length - 1 - k))
                        .easing(Easing.Cubic.In)
                        .onComplete(() => {
                            const symbolId: number = symbol.id;

                            if (isLandingAnimationExist(symbolId)) {
                                if (symbolId === 13) {
                                    symbol.symbol.state.setAnimation(0, "land", false).listener = {
                                        complete: () => {
                                            symbol.symbol.state.clearListeners();
                                            symbol.symbol.state.setAnimation(0, "idle", true);
                                        }
                                    }
                                }
                                else {
                                    symbol.symbol.state.setAnimation(0, "land", false);
                                }
                            }

                            reelTweenGroup.remove(tween);

                            if (!isReelStopSoundPlayed) {
                                isReelStopSoundPlayed = true;
                                this.playReelStop(reelObj.reelIndex, isNewSpin, swirlLanded);
                            }

                            resolve(); // Resolve the promise when this animation completes
                        })
                        .start();
                });

                animationPromises.push(promise);
            }
        });

        // Wait for all animations to complete before resolving the parent promise
        await Promise.all(animationPromises);


        // })
        //
    }


    public resetSymbolPositions() {

        this.allReelArray.forEach((reelObj) => {

            reelObj.symbols.forEach((symbol) => {
                const targetPos = symbol.y;
                const symbolContainer = symbol.view;
                symbolContainer.y = targetPos;

            })

        })
    }

    private playReelStop(reelIndex: number, isNewSpin: boolean, fistLanded: boolean) {
        if (this.quickStop || this.superQuickStop || !isNewSpin) {

            if ((this.quickStop || this.superQuickStop) && reelIndex == 0) { // only reel_stop_quick should play once
                // sound.play('reel_stop_quick', { volume: 0.5 });
                sound.play(fistLanded ? 'Special_Symbol_Landing' : 'reel_stop', { volume: 0.2 });
                // console.log("reel_stop", reelIndex);
            }
            else if (!isNewSpin && !this.isCascadeStopSoundPlayed) {
                this.isCascadeStopSoundPlayed = true;
                sound.play(fistLanded ? 'Special_Symbol_Landing' : 'reel_stop', { volume: 0.2 });
            }
        }
        else {
            sound.play(fistLanded ? 'Special_Symbol_Landing' : 'reel_stop', { volume: 0.2 });

            // console.log("reel_stop", reelIndex);
        }
    }


    // private swapTextures(symbols: Sprite[], predifinedSymbolData: number[]) {
    //     symbols.forEach((symbol, i) => {
    //         let id = predifinedSymbolData[i]
    //         const textureOfSymbol = getSymbol(id);
    //         symbol.texture = textureOfSymbol;
    //     });
    // }

    public reelMove1CompletePromise: Promise<void>;

    private isCascadeStopSoundPlayed = true;

    public async startReels(currentRespinIndex: number, isNewSpin: boolean, spinStype: string): Promise<void> {

        console.log("inside startReels in class ReelSpin ")


        this.quickStop = isQuickBtnOnGlobal;
        this.superQuickStop = isSuperQuickBtnOnGlobal;

        // let additionalTargetAnticipation = 0;

        // now tween on each reel will start

        // this.winTemp();

        // this.allReelArray.forEach((reelObj)=>{
        //     this.cascadeReels(reelObj);
        // })

        this.resetTweenGroup()
        // this.quickStop = this.ui.burgerMenuObj.isTurboBtnOn;

        // await new Promise(resolve => setTimeout(resolve, 200));

        let moveStep1CompleteResolve!: () => void;
        // Initialize moveStep1Complete as a new promise
        this.reelMove1CompletePromise = new Promise<void>((resolve) => {
            moveStep1CompleteResolve = resolve;
        });



        const promises: Promise<void>[] = [];

        this.allReelArray.forEach((reelObj, i) => {
            const promise = new Promise<void>((resolve) => {
                const timeoutId = setTimeout(() => {
                    this.spinAReel(reelObj, isNewSpin).then(resolve);
                    clearTimeout(timeoutId);
                }, (isNewSpin ? ((this.quickStop || this.superQuickStop) ? 0 : i * 100) : 0));
            });
            promises.push(promise);
        });

        await Promise.all(promises);

        // Resolve moveStep1Complete when this line is reached
        moveStep1CompleteResolve();

        await this.waitForData();

        // if (spinData.respins[currentRespinIndex].initReelsMultiplier.length > 0) {
        //     reelSpinEmitter.emit('updateReelMultiplier', spinData.respins[currentRespinIndex].initReelsMultiplier);
        //     sound.play('multiplier_travels');

        //     await new Promise(resolve => setTimeout(resolve, 500));
        // }

        // await this.knockoutFeatureCellOnOff(currentRespinIndex, true);


        if (!isNewSpin) {
            this.isCascadeStopSoundPlayed = false;
        }

        const promises2: Promise<void>[] = [];
        this.allReelArray.forEach((reelObj) => {

            const jurisdictionDelay = isNewSpin ? ((this.quickStop || this.superQuickStop) ? 0 : (reelObj.reelIndex) * (100 + (spinStype === "BASE" ? this.spinTime : 0))) : 0;
            // (total_time - 1250)/5
            // for 5000ms value will be (5000-1250)/5 = 750 --- 350
            // for 3000ms value will be (3000-1250)/5 = 350 --- 150
            // for 2500ms value will be (2500-1250)/5 = 250 --- 
            // for 2000ms value will be (2000-1250)/5 = 150 
            // for 1000ms value will be (1000-1250)/5 = 0 --- 0 


            const promise = new Promise<void>((resolve) => {
                const timeoutId = setTimeout(() => {
                    this.moveAReelStep2(reelObj, currentRespinIndex, isNewSpin).then(() => {
                        // console.log(`moveAReelStep2 completed for reelIndex: ${reelObj.reelIndex}`);
                        resolve();
                    });
                    clearTimeout(timeoutId);
                }, jurisdictionDelay);
            });

            promises2.push(promise);
        });

        await Promise.all(promises2);

        // await this.knockoutFeatureCellOnOff(currentRespinIndex, false);

        await this.putGiantWild(currentRespinIndex);

        await this.putRandomWild(currentRespinIndex);


        // await this.activateFistFeature(currentRespinIndex);


        // await this.waitForData();
        // await new Promise(resolve => setTimeout(resolve, jurisdictionDelay));


        await this.allReelStop();

        console.log("reel spin done");


    }

    private spinTime: number = 0;
    private setSpinTimeJurisdiction(): number {

        this.spinTime = 0;

        switch (jurisdictionGlobal) {
            //3000ms
            case "colombia":
            case "denmark":
            case "spain":
            case "sweden":
            case "colombia":
            case "bclc":
            case "uk":
            case "ontario":

                this.spinTime = 125;
                break;
            case "lithuania":
                this.spinTime = -50; //5000ms
                break;

            case "germany":
                this.spinTime = 300; //5000ms
                break;
            case "greece":
                this.spinTime = 0; //5000ms
                break;

            //  -- 1000ms

            default:
                this.spinTime = 0;
                break;
        }

        return (this.spinTime);
    }





    // private async waitAfterReelStop(time: number): Promise<void> {
    //     return new Promise((resolve) => {

    //         const timeoutId = setTimeout(() => {
    //             resolve();
    //             clearTimeout(timeoutId);
    //         }, time);

    //     })
    // }




    private async allReelStop() {

        // this.ui.spin.interactive = true;

        // this.running = false;


        // this.ui.spin.visible = true;
        // this.ui.slam.visible = false;

        // console.log(sound.isPlaying('reel_spin_loop'));

        // sound.stop('reel_spin_loop');
        // sound.stop('reel_spin_loop');

        // await this.waitAfterReelStop((this.quickStop || this.superQuickStop) ? 0 : 100);

        // Resolve the promise to signal that all work is done
        if (this.resolveReelsStop) {
            this.resolveReelsStop();
            this.resolveReelsStop = null; // Reset the resolver
        }

    }



    // Add other methods as needed
}
